<ng-container *transloco="let t; prefix: 'unauthorized'">
  <div
    class="t-flex t-flex-col t-items-center t-justify-center t-min-h-[60vh] t-text-center t-px-4"
  >
    <div
      class="t-w-24 t-h-24 t-rounded-full t-bg-red-100 t-flex t-items-center t-justify-center t-mb-6"
    >
      <i class="pi pi-lock t-text-4xl t-text-red-600"></i>
    </div>

    <h1 class="t-text-3xl t-font-semibold t-text-gray-800 t-mb-3">
      {{ t("title") }}
    </h1>

    <p class="t-text-gray-600 t-max-w-md t-mb-2">
      {{ t("message") }}
    </p>

    <p class="t-text-gray-500 t-max-w-md t-mb-6">
      {{ t("contactAdmin") }}
    </p>

    <p-button
      [label]="t('logout')"
      icon="pi pi-sign-out"
      (onClick)="logout()"
    />
  </div>
</ng-container>
